import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {CommonModule} from '@angular/common';
import {LeftNavComponent} from './left-nav.component';
import {AuthModule} from '../../components/security/authorization/auth.module';

@NgModule({
    imports: [CommonModule, RouterModule, AuthModule],
    declarations: [LeftNavComponent],
    exports: [LeftNavComponent]
})
export class LeftNavModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/navigation/left/left-nav.module.ts